/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import {
  getBraindateConversation,
  getBraindatePod,
} from '@e180/domain/lib/braindate/util';
import { isNumber } from '@e180/util/lib/type';

import withMeetingPoints from 'src/shared/app/base/component/hoc/withMeetingPoints';
import { isConversationAboutGroupBraindate } from 'src/shared/domain/conversation/util/conversationUtil';
import PinIcon from 'src/shared/ui/component/icon/PinIcon';

import type { Braindate } from '@e180/domain/lib/braindate/type';

type Props = {
  altText?: string,
  braindate: Braindate,
  layoutClass?: string,
  // Self passed
  oneOneOnePodIcons: Array<string>,
  groupPodIcons: Array<string>,
};

const PodIcon = ({
  altText,
  braindate,
  layoutClass,
  oneOneOnePodIcons,
  groupPodIcons,
}: Props): React.Node => {
  const conversation = getBraindateConversation(braindate);
  const isGroupBraindate = isConversationAboutGroupBraindate(conversation);

  const pod = getBraindatePod(braindate);

  let podIcon;

  if (pod && isNumber(pod)) {
    if (isGroupBraindate) {
      if (groupPodIcons && groupPodIcons.length) {
        podIcon = groupPodIcons[pod - 1];
      }
    } else {
      if (oneOneOnePodIcons && oneOneOnePodIcons.length) {
        podIcon = oneOneOnePodIcons[pod - 1];
      }
    }
  }

  const iconElt = podIcon ? (
    <img className={layoutClass} src={podIcon} alt={altText} />
  ) : (
    <PinIcon layoutClass={layoutClass} />
  );

  return iconElt;
};

export default compose(React.memo, withMeetingPoints)(PodIcon);
